import { setAuthorization } from "../../helpers/api_helper";
import {
  resend_otp,
  scheduleTokenRefresh,
  verifyOtpCode,
} from "../../helpers/AuthType/authBackend";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Input,
  Row,
} from "reactstrap";
import { encryptState } from "shared/encryptInfo";
import { RootState } from "slices";
import { rolesPermissions } from "slices/auth/login/reducer";
import { logOutUser } from "../../helpers/dataBackend";

const TwostepVerification = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [alertError, setAlertError] = useState(false);
  const [error, setError] = useState<any>();
  const dispatch: any = useDispatch();

  document.title = "Two Step Verification";

  const { user } = useSelector((state: RootState) => state.Login);

  const handleVerify = async () => {
    const otpCode = otp.join("");
    if (otpCode.length < 6) {
      alert("Please enter the complete 6-digit code.");
      return;
    }
    const objVerify = {
      email: user, //CAMBIAR ESTE CORREO POR EL QUE VIENE DEL STATE
      otp_code: otpCode,
    };
    try {
      const response = await verifyOtpCode(objVerify);
      const dataParse = JSON.parse(response.data);
      if (dataParse.token) {
        const refreshToken = dataParse.refreshToken;
        localStorage.setItem("authUser", dataParse.token);
        scheduleTokenRefresh(dataParse.token);
        const encryptedData = encryptState(dataParse.userInfo);
        localStorage.setItem("userInfo", encryptedData);
        const tokenEncrypted = encryptState(refreshToken);
        localStorage.setItem("refreshToken", tokenEncrypted);
        dispatch(rolesPermissions(dataParse)); // Teniendo en cuenta que las estructura del response no cambia se envia todo el response
        navigate("/dashboard");
      }
    } catch (error) {
      setAlertError(true);
      setError("Codigo OTP inválido o expirado");
    }
  };

  // Manejar cambios en los inputs
  const handleChange = (index: any, value: any) => {
    if (!/^\d*$/.test(value)) return; // Solo permitir números

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // Asegurar un solo dígito por campo
    setOtp(newOtp);

    // Mover al siguiente input automáticamente si se ingresó un número
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`)?.focus();
    }
  };

  // Manejar cuando el usuario pega un código
  const handlePaste = (e: any) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();

    if (!/^\d{6}$/.test(pastedData)) return; // Solo aceptar 6 dígitos

    const newOtp = pastedData.split("");
    setOtp(newOtp);

    // Mover el foco al último campo
    document.getElementById(`otp-input-${5}`)?.focus();
  };

  const validateLocalStorage = () => {
    const token = localStorage.getItem("authUser");
    setAuthorization(token);
    if (localStorage.getItem("authUser")) {
      logOutUser();
      localStorage.clear();
    }
  };

  useEffect(() => {
    validateLocalStorage();
  }, [dispatch]);

  const onClickResend = async () => {
    const resendCode = { email: user, source_request_id: 1 };
    try {
      // console.log(resendCode);
      await resend_otp(resendCode);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card>
              <CardBody>
                <div className="p-2 text-center">
                  <div className="avatar-md mx-auto">
                    <div className="avatar-title rounded-circle bg-light">
                      <i className="bx bxs-envelope h1 mb-0 text-primary"></i>
                    </div>
                  </div>
                  <h4 className="mt-4">Verify your email</h4>
                  <p>Please enter the 6-digit code sent to {user}</p>

                  <Form>
                    <Row>
                      {otp.map((digit, index) => (
                        <Col key={index}>
                          <div className="mb-3">
                            <Label className="visually-hidden">
                              Digit {index + 1}
                            </Label>
                            <Input
                              id={`otp-input-${index}`}
                              type="text"
                              className="form-control form-control-lg text-center two-step"
                              maxLength={1}
                              value={digit}
                              onChange={(e) =>
                                handleChange(index, e.target.value)
                              }
                              onPaste={handlePaste} // Detectar pegado
                            />
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Form>

                  {alertError ? <p style={{ color: "red" }}>{error}</p> : null}

                  <div className="mt-4">
                    <button
                      className="btn btn-success w-md"
                      type="button"
                      onClick={handleVerify}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </CardBody>
            </Card>
            <div className="mt-5 text-center">
              <p>
                Didn't receive a code?{" "}
                <Link
                  to="#"
                  onClick={onClickResend}
                  className="fw-medium text-primary"
                >
                  Resend
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TwostepVerification;
